import { useContext } from 'react'

import { OptimizerStorangeContext } from '@provider/Optimizer/OptimizerStorange'

import { IOptimizerStorangeContext } from '@base/@types/providers/Optimizer/Optimizer'

export default function useOptimizerStorange(): IOptimizerStorangeContext {
  const context = useContext(OptimizerStorangeContext)

  return context
}
